export enum DeviceType {
    DESKTOP = 'DESKTOP',
    MOBILE = 'MOBILE',
}
